import { useTranslation } from "react-i18next";

/**
 * What a model's answer rests on, under the answer: the kind of knowledge it
 * says it used, and — folded away until asked for — exactly what the cellar
 * told it.
 *
 * Asked for by the owner on 2026-09-27, for the drinking window and the meal
 * question after the quality report. **Not sources**, and the fold says so in
 * as many words: the model looks nothing up, so there are no reviews behind
 * any of this, and a label reading *grund: tabellen för klassiska områden*
 * must not be mistaken for a citation somebody could go and check.
 *
 * **What it was told is the half that cannot be wrong.** The labels are the
 * model's own account of itself; the facts are what the code sent, frozen when
 * the question was asked. When an answer surprises, the facts are usually why —
 * a cabinet recorded at 18 °C, a missing disgorgement date — and they are the
 * one thing here the owner can correct.
 */
export function AnswerGrounds({
  labels,
  told,
}: {
  /** Already in Swedish. Nothing drawn when empty — an answer from before
   *  this was asked for has no basis, and saying *grund: –* would imply one. */
  labels: readonly string[];
  /** Null on answers from before the facts were kept. */
  told: string | null;
}) {
  const { t } = useTranslation();
  if (labels.length === 0 && told === null) return null;

  return (
    <div className="mt-1">
      {labels.length > 0 && (
        <p className="text-muted text-xs">
          {t("grounds.basis", { basis: labels.join(" · ") })}
        </p>
      )}
      {told !== null && (
        <details className="mt-1">
          <summary className="text-accent cursor-pointer text-xs">
            {t("grounds.told")}
          </summary>
          <p className="text-muted mt-1 max-w-prose text-xs">
            {t("grounds.notLookedUp")}
          </p>
          <pre className="text-muted mt-1 max-w-prose font-sans text-xs whitespace-pre-wrap">
            {told}
          </pre>
        </details>
      )}
    </div>
  );
}
